export default __webpack_public_path__ + "static/media/Puppeteer Attack.2a134c74.png";